<template>
  <div>
    <div>
      <div class="mt-4 mx-2">
				<v-row class="mb-2">
					<v-col md="6">
						<div class="text-h5 ml-3 float-left" >
              <v-tooltip top v-if="settings.level>50">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small @click="getData()" v-bind="attrs" fab class="neu-glow float-left mr-5" active-class="neu-glow-inset" v-on="on" :loading="loading">
                    <v-icon 
                     large
                      color="info"
                      class="mx-3"
                      active-class="neu-glow-inset"
                      >
                        mdi-sync-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
							Segreteria Virtuale: {{settings.options.pbxNumber.slice(2).replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '($1) $2 $3 $4') }}
						</div>
					</v-col>
          <v-col cols="6" class="text-right pr-8" v-if="expired">
            <span class="float-left text-h5">Numero Chiamate: {{messages?messages.length:'0'}}</span>
            <v-spacer></v-spacer>
            <span>
              <v-btn @click="dialog_range=true">Periodo {{rangeString}}</v-btn>
            </span>
          </v-col>          
				</v-row>
        <v-row v-if="expired">
          <v-col cols="12">
            <v-card class="neu-glow mx-4">
                <v-row>
                  <v-col>
                    <v-alert
                      class="float-left mb-0"
                      v-if="expired.showAlert"
                      :max-width="750"
                      text
                      dense
                      transition="scale-transition"
                      type="error"
                    >
                      <v-row
                        align="center"
                        no-gutters
                      >
                        <v-col v-if="expired.expired" class="grow font-weight-bold">
                          Modulo Scaduto il {{expired.expiry}}: Vai al carrello per riattivarlo
                        </v-col>
                        <v-col v-else class="font-weight-bold">
                          Questo Modulo scade il {{expired.expiry}}: Vai al carrello per Estenderne la durata
                        </v-col>
                        <v-col class="shrink font-weight-bold pl-8">
                          <v-btn
                            small
                            to='/shop'
                            color="info"                            
                          >
                            Estendi
                          </v-btn>
                        </v-col>
                      </v-row>                    
                    </v-alert>  
                  </v-col>
                </v-row>
                <v-row v-if="!expired">
                  <v-col cols="12">
                    <v-card-text>
                      <v-card style="margin-top:6%" :height="wHeight-250" class="text-center">
                          <v-progress-circular
                            :size="wHeight-450"
                            width="35"
                            color="info"
                            indeterminate
                          ></v-progress-circular>
                      </v-card>           
                  </v-col>
                </v-row>
                <v-row v-else>  
                <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
                  <v-data-table
                    dense
                    fixed-header
                    :headers="headers"
                    :items="messages||[]"
                    hide-default-footer
                    :items-per-page=500
                    :height="wHeight-195"
                    :loading="loading"
                    no-data-text="Nessun dato presente in archivio"
                    no-results-text="Nessun Risultato estratto"
                    loading-text="Consultazione archivio: attendi..."
                  >
                    <template v-slot:[`item.callerId`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <a :href="'tel:+'+item.callerId" style="text-decoration:none;" class="pt-2 pl-2">
                            <span class="mr-2">{{item.callerId}}</span>
                            <v-icon @click="markCalled(item)" :class="item.called?'grey--text':(item.DTMF=='R'?'error--text':(item.hasBooking?'success--text':'warning--text'))" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                          </a>
                        </template>
                        <span>{{item.DTMF=='R'?'Attende Chiamata':item.hasBooking?'prenotato':(item.called?'Chiamata '+item.called:'Chiama')}}</span>
                      </v-tooltip>
                    </template>

                    <!--
                      <template v-slot:[`item.status`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-icon class="error--text" v-if="item.status=='failed'">mdi-alert-circle</v-icon>
                            <v-icon class="grey--text" v-if="item.status=='sent'">mdi-check</v-icon>
                            <v-icon :class="item.status=='delivered'?'grey--text':'info--text'" v-if="item.status=='delivered'||item.status=='read'">mdi-check-all</v-icon>
                          </div>
                        </template>
                        <span>{{item.status}}</span>
                      </v-tooltip>
                    </template>
                    -->

                    <template v-slot:[`item.WAStatus`]="{ item }">
                      <v-tooltip top :disabled="!item.WAStatus">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-icon :color="item.WAColor">{{item.WAIcon}}</v-icon>
                          </div>
                        </template>
                        <span>{{$t(page+'.'+item.WAStatus)}}{{item.errorMessage?' :'+item.errorMessage:''}}</span>
                      </v-tooltip>
                    </template>                    

                    <template v-slot:[`item.active`]="{ item }">
                      <v-simple-checkbox
                        v-bind="attrs" v-on="on"
                        v-model="item.active"
                        color="success"
                        readonly
                      ></v-simple-checkbox>
                    </template>

                  </v-data-table>
                </v-col>
                <v-col cols="12" v-else>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Cerca:"
                    color="info"
                    single-line
                    hide-details
                    class="float-right mt-n2"
                    style="max-width:250px"
                  ></v-text-field>                      
                  <v-data-table
                    dense
                    fixed-header
                    :headers="headers_2"
                    :items="messages||[]"
                    hide-default-footer
                    :items-per-page=500
                    :height="wHeight-235"
                    :loading="loading"
                    no-data-text="Nessun dato presente in archivio"
                    no-results-text="Nessun Risultato estratto"
                    loading-text="Consultazione archivio: attendi..."
                    :search="search"
                  >
                    <template v-slot:[`item.callerId`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <a :href="'tel:+'+item.callerId" style="text-decoration:none;" class="pt-2 pl-2">

                            <span class="mr-2">{{item.callerId}}</span>
                            <v-icon @click="markCalled(item)" :class="item.called?'grey--text':(item.DTMF=='R'?'error--text':(item.hasBooking?'success--text':'warning--text'))" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                            <v-icon class="error" v-if="item.status=='failed'">mdi-alert-circle</v-icon>
                            <v-icon class="grey" v-if="item.status=='sent'">mdi-check</v-icon>
                            <v-icon :class="item.status=='delivered'?'grey':'info'" v-if="item.status=='delivered'||item.status=='read'">mdi-check-all</v-icon>
                          </a>
                        </template>
                        <span>{{item.hasBooking?'prenotato':item.called?'Chiamata '+item.called:(item.toBeCalled?'Attende Chiamata':'Chiama')}}|{{item.status}}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.WAStatus`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <div class="mr-3 float-left">{{item.DTMF}}</div>
                            <v-icon :color="item.WAColor">{{item.WAIcon}}</v-icon>
                          </div>
                        </template>
                        <span>{{$t(page+'.'+item.WAStatus)}}{{item.errorMessage?' :'+item.errorMessage:''}}</span>
                      </v-tooltip>
                    </template>   

                    <template v-slot:[`item.active`]="{ item }">
                      <v-simple-checkbox
                        v-bind="attrs" v-on="on"
                        v-model="item.active"
                        color="success"
                      ></v-simple-checkbox>
                    </template>

                  </v-data-table>
                </v-col>                
              </v-row>
            </v-card>
          </v-col>                      
        </v-row>
      </div>
    </div>
    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;getData()">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="dateRange"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>      
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: "Booking",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      messages:null,
      loading:false,
      dialog_range:false,
      expired:null,
      search:null,
      dateRange:[new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().substring(0, 10),new Date().toISOString().substring(0, 10)],
      headers: [
                { text: 'Data e Ora',   value: 'callStart',   align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                //{ text: '€cts',        value: 'callCost',   align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Numero',       value: 'callerId',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'DTMF',         value: 'DTMF',        align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Messaggio WA', value: 'WAStatus',      align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                //{ text: 'Prenotazione', value: 'bookingId',   align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Pren. Attiva', value: 'active',      align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Nome',         value: 'fullName',    align: 'start',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Data',         value: 'date',        align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Ora',          value: 'time',        align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Coperti',      value: 'covers',      align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ], 
      headers_2: [
                { text: 'Data e Ora',   value: 'callStart',   align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Numero',       value: 'callerId',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Nome',         value: 'fullName',    align: 'start',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'WA/DTMF',      value: 'WAStatus',    align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Pren. Attiva', value: 'active',      align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ],                    
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    rangeString: function()
    {
      console.log(260,this.dateRange)
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(this.dateRange[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.dateRange[1]).toLocaleDateString('it', options)
    } 
  },
  created(){
    console.log(1357,this.settings)
    if (this.settings&&this.settings.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }
  },
  watch:
  {/*
    dateRange(newValue,oldValue)
    {
      console.log(293,newValue,oldValue)
      if(newValue!=oldValue)
      {
        this.getData()
      }
    }*/
  },
  methods:
  {
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"dateRange": this.dateRange,"action":"PBX_incomingMessages_get"});
                const res = await this.$http.post('/pbx/pbx.php', payload );
                console.log(126,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.messages=res.data.payloads.messages||[];
                      this.expired=res.data.payloads.expired;
                      console.log(132,this.messages);
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async markCalled (item)
    {
        let payload={"action":"PBX_Messages_Called_set","payload":JSON.stringify(item)};
        console.log(113,payload)
        const idx=this.messages.findIndex(m =>m.callId==item.callId)
        console.log(119,idx)
        this.messages[idx].called=new Date;
        let w= await this.updateDB(payload)
        console.log(122,w);       
        this.snackbar=false;
        if (w.errorid=='0')
        {
            //console.log(126,w.payloads.callId)
            //const idx=this.messages.findIndex(m =>m.callId==w.payloads.callId)
            //console.log(128,idx)
            //this.messages[idx].called=new Date;
            //console.log(130,this.messages)
        }	
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/pbx/pbx.php', payload);
            console.log(127,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              if (res.data.payloads)
              {
                  console.log(133);
                  //this.snackbar=true;
              }
            }
            else
            {
              console.log(139);
              //this.$router.push('/auth/login').catch(() => {});
            }
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },    
  },
};
</script>
<style scoped>
.v-data-table__mobile-row{
  min-height: 24px!important;
}
</style>